import type { WorkspaceTransform } from "@/lib/workspace-view-adapter";

interface ConversationFrameExpansionArgs {
  baseX: number;
  baseWidth: number;
  delta: number;
  edgeInset: number;
  expansionBaseWidth?: number;
  minWidth: number;
  /** The workspace view's transform (client pixels). */
  transform: WorkspaceTransform;
  /** The width of the surface the view fills from the window's left edge. */
  surfaceWidth: number;
}

export function conversationFrameExpandedGeometry({
  baseX,
  baseWidth,
  delta,
  edgeInset,
  expansionBaseWidth,
  minWidth,
  transform,
  surfaceWidth,
}: ConversationFrameExpansionArgs) {
  const extraWidth = Math.max(0, delta);
  const targetBaseWidth = expansionBaseWidth ?? baseWidth;
  const expansionTargetWidth = Math.max(
    baseWidth,
    targetBaseWidth + extraWidth,
  );
  const width = Math.max(minWidth, expansionTargetWidth);
  const appliedExtraWidth = Math.max(0, expansionTargetWidth - baseWidth);
  const zoom = transform.zoom || 1;
  const maxRight = surfaceWidth - edgeInset;
  const expandedRight = (baseX + width) * zoom + transform.x;
  const overflowRight = Math.max(0, expandedRight - maxRight);
  const shiftLeft = Math.min(appliedExtraWidth, overflowRight / zoom);

  return {
    x: baseX - shiftLeft,
    width,
  };
}
